module.exports = "{{_command?._display}}\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/common/params/param-label.component.html
// module id = 1535
// module chunks = 2